/*
 * File: DeliveryAddressStateSelector.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 18 Jan 2022 12:48:55 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Form, Select } from 'antd';
import { useSelector } from 'react-redux';
import { useGetWorldsQuery } from 'redux/services/chuckieSue/worldsApi';
import { ReduxState } from 'redux/store';

interface Props {
  disabled: boolean;
}

export const DeliveryAddressStateSelector = ({ disabled }: Props): JSX.Element => {
  const { acuityContext } = useSelector((state: ReduxState) => state.app);
  const { data, isLoading } = useGetWorldsQuery(undefined, { skip: !acuityContext?.selectedCustomer.business.dataAreaId });
  const form = Form.useFormInstance();
  const countryCode = form.getFieldValue('country');
  const state = form.getFieldValue('state');

  /* ****************** JSX / Variables ****************** */

  const stateOptions = data?.data[0].countries.find((country) => country.alpha2Code === countryCode)?.subdivisions.map((subdivision) => ({ label: subdivision.name, value: subdivision.name }));

  const handleSelect = (value: string): void => {
    form.setFieldValue('state', value);
  };

  /* ****************** Render  ****************** */
  return (
    <Select
      loading={isLoading}
      onSelect={handleSelect}
      showSearch
      value={state || undefined}
      disabled={disabled}
      options={stateOptions}
      filterOption={(input, option): boolean => {
        if (option?.label) {
          return (option?.label as unknown as string).toLowerCase().includes(input.toLowerCase());
        } else {
          return false;
        }
      }}
    />
  );
};
